// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button[data-v-82841c1a] {\n  background-color: var(--primary);\n  padding: 0.75rem 3.5rem;\n  border-radius: 0.25rem;\n  color: white;\n  font-size: 0.875rem;\n}\n.button--secondary[data-v-82841c1a] {\n  background-color: rgba(74, 98, 212, 0.2);\n  padding: 0.75rem 3.5rem;\n  border-radius: 0.25rem;\n  color: #242424;\n  font-size: 0.875rem;\n}\n.button--disabled[data-v-82841c1a] {\n  background-color: #E5E7EB;\n  color: gray;\n  cursor: not-allowed;\n}", ""]);
// Exports
module.exports = exports;
